export default "__VITE_ASSET__696948df__"